window.$ = window.jQuery = require("jquery");
require("bootstrap-sass");
const Hogan = require("hogan.js");
const Swiper = require("swiper");
const { $cm } = require("./cart-manager");
window.fancybox = require("@fancyapps/fancybox");

export function ProductManager(inventory, root, config) {
    var self = this;
    self.initComplete = false;
    self.inventory = inventory || [];
    self.slideChange = false;
    self.sizeType = null;
    self.sizechartID = null;
    self.productRoot = root || $(".product-detail");
    self.config = $.extend(
        {
            isMaster: true,
            noColor: "",
            noSize: "",
            relatedProducts: [],
            masterProduct: null,
            alternatives: null
        },
        config
    );

    // Stich ourselves together
    $.each(self.config.relatedProducts, function(idx, pm) {
        pm.setMasterProduct(self);
    });

    if ($("#product-ld-json-template").length) {
        self.ldJsonTemplate = Hogan.compile($("#product-ld-json-template").html());
    }

    // Check for color selection in url and save it!
    var qd = {};
    location.hash
        .substr(1)
        .split("&")
        .forEach(function(item) {
            qd[item.split("=")[0]] = item.split("=")[1];
        });
    if (!qd["color"] && !qd["size"]) {
        // Try again using query string
        location.search
            .substr(1)
            .split("&")
            .forEach(function(item) {
                qd[item.split("=")[0]] = item.split("=")[1];
            });
    }

    self.gaEvent = function(action) {
        var category = self.config.isMaster ? "product" : "completeTheLook";
        var label = self.productRoot.find(".product-style").html();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "GAEvent",
            eventCategory: category,
            eventAction: category + "-" + action,
            eventLabel: category + "-" + action + "-" + label,
            eventValue: ""
        });
    };

    self.setMasterProduct = function(pm) {
        self.config.masterProduct = pm;
    };

    self.setSizeType = function(item) {
        // Ensure size type exists
        var sizechartID = item.data("sizechart");
        if (!self.productRoot.find('[data-sizechart="' + sizechartID + '"]').length) {
            item = self.productRoot.find("[data-sizechart]").first();
        } else {
            item = self.productRoot.find('[data-sizechart="' + sizechartID + '"]').first();
        }
        self.sizeType = item.data("value");
        self.sizechartID = item.data("sizechart");

        if (self.swiper) {
            self.swiper.destroy(true, true);
            self.swiper = null;
        }

        // Set item and name
        self.productRoot.find(".product-name").html(item.data("name"));
        self.productRoot.find(".product-style").html(item.data("style"));

        self.productRoot.find("[data-size-type]").hide();
        self.productRoot.find('[data-size-type="' + self.sizeType + '"]').show();

        if (
            self.productRoot.find('.swiper-container[data-size-type="' + self.sizeType + '"]')
                .length
        ) {
            self.swiper = new Swiper(
                self.productRoot.find('.swiper-container[data-size-type="' + self.sizeType + '"]'),
                {
                    loop: true,
                    spaceBetween: 10,
                    // grabCursor: true,
                    paginationClickable: true,
                    preventClicks: true,
                    pagination: ".swiper-pagination",
                    nextButton: ".swiper-button-next",
                    prevButton: ".swiper-button-prev",
                    onSlideChangeEnd: function(swiper) {
                        var newColor = $(swiper.slides[swiper.activeIndex]).data("colorcode");
                        if (
                            newColor !=
                            self.productRoot.find(".swatch-image.selected").data("colorcode")
                        ) {
                            self.slideChange = true;
                            self.productRoot.find(".swatch-image").removeClass("selected");
                            self.productRoot
                                .find('.swatch-image[data-colorcode="' + newColor + '"]')
                                .addClass("selected");
                            self.updateControls(false);
                            self.slideChange = false;
                        }
                    }
                }
            );
        }

        // We're making a change, so clear selected color and size
        self.productRoot.find(".swatch-size, .swatch-image").removeClass("selected");
        self.updateControls(false);

        $.each(self.config.relatedProducts, function(idx, pm) {
            pm.setSizeType(item);
        });
    };

    self.sizeTypeChange = function() {
        var item = self.productRoot.find('input[name="size-type"]:checked');
        var type = item.val();
        if (
            !self.sizeType ||
            self.productRoot.find('[data-size-type="' + type + '"]').is(":hidden")
        ) {
            self.setSizeType(item);
        }
    };

    self.setSwatchState = function(curSize, curColor) {
        if (self.sizechartID) {
            self.productRoot.find(".swatch-size, .swatch-image").tooltip("destroy");
            self.productRoot.find(".swatch-size, .swatch-image").addClass("sold-out");
            self.productRoot.find(".price-group").removeClass("selected not-selected");
            // self.productRoot.find('.color-options').find('.separator').removeClass('hidden');
            if (self.inventory[self.sizechartID]) {
                $.each(self.inventory[self.sizechartID], function(colorcode, colorSizes) {
                    $.each(colorSizes, function(size, item) {
                        if (item.avail) {
                            if (!curColor || curColor == colorcode) {
                                self.productRoot
                                    .find('.swatch-size[data-stylesize="' + size + '"]')
                                    .removeClass("sold-out");
                            }
                            if (!curSize || curSize == size) {
                                self.productRoot
                                    .find('.swatch-image[data-colorcode="' + colorcode + '"]')
                                    .removeClass("sold-out");
                            }
                        }
                    });
                });
            }

            self.productRoot.find(".swatch-size.sold-out, .swatch-image.sold-out").tooltip({
                title: "Out of stock",
                trigger: "hover"
            });

            if (curColor) {
                var curColorCtl = self.productRoot.find(
                    '.swatch-image[data-colorcode="' + curColor + '"]'
                );
                self.productRoot.find(".selected-color").html(curColorCtl.data("colorname"));
                self.productRoot.find(".price-group").addClass("not-selected");
                var priceGroup = curColorCtl
                    .closest(".price-group")
                    .removeClass("not-selected")
                    .addClass("selected");
                if (priceGroup.hasClass("regular-price")) {
                    // Any regular price selection ensures all regular price options are shown
                    self.productRoot.find(".regular-price").show();
                    self.productRoot.find(".show-all-colors").hide();
                }
            } else {
                self.productRoot.find(".selected-color").html(self.config.noColor);
            }
            if (curSize) {
                self.productRoot.find(".selected-size").html(curSize);
            } else {
                self.productRoot.find(".selected-size").html(self.config.noSize);
            }

            var item = self.getInventory(curSize, curColor);
            if (item) {
                self.productRoot.find('input[name="prodID"]').val(item.id);
                self.productRoot.find(".product-style").html(item.style);
                var stock = item.stock || self.productRoot.find(".restock-date").data("default");
                self.productRoot.find(".restock-date").html(stock);
            }
            if ((item && item.avail) || !curSize || !curColor) {
                self.productRoot.find(".btn-add-to-bag").show();
                self.productRoot.find(".btn-sold-out").hide();
                self.productRoot.find(".waitlist-notify").hide();
                if (self.config.alternatives && window.jrConfig.vue && window.jrConfig.vue.$refs) {
                    var pa = window.jrConfig.vue.$refs[self.config.alternatives];
                    if (pa) {
                        pa.setInStock();
                    }
                }
            } else {
                // OUT OF STOCK
                self.productRoot.find(".btn-add-to-bag").hide();
                if (item && item.wait) {
                    self.productRoot.find(".btn-sold-out").hide();
                    self.productRoot.find(".waitlist-notify").show();
                } else {
                    self.productRoot.find(".btn-sold-out").show();
                    self.productRoot.find(".waitlist-notify").hide();
                }
                if (self.config.alternatives && window.jrConfig.vue && window.jrConfig.vue.$refs) {
                    var pa = window.jrConfig.vue.$refs[self.config.alternatives];
                    if (pa) {
                        pa.setOutOfStock(self.sizechartID, curColor, curSize);
                    }
                }
            }

            self.priceGroupSeparator();
        }
    };

    self.priceGroupSeparator = function() {
        self.productRoot.find(".price-group").removeClass("separator");
        self.productRoot
            .find(".price-group:visible")
            .slice(1)
            .addClass("separator");
    };

    self.getInventory = function(curSize, curColor) {
        if (curSize && curColor && !$.isEmptyObject(self.inventory) && self.sizechartID) {
            var sizeInventory = self.inventory[self.sizechartID] || Object.keys(self.inventory)[0];
            if (curColor && !sizeInventory[curColor]) {
                curColor = undefined;
            }
            curColor = curColor || Object.keys(sizeInventory)[0];
            curSize = curSize || Object.keys(sizeInventory[curColor])[0];
            if (curColor in sizeInventory && curSize in sizeInventory[curColor]) {
                return $.extend({}, sizeInventory[curColor][curSize], {
                    colorcode: curColor,
                    stylesize: curSize
                });
            }
        }
        return null;
    };

    self.currentItem = function() {
        var curSize = self.productRoot.find(".swatch-size.selected").data("stylesize");
        var curColor = self.productRoot.find(".swatch-image.selected").data("colorcode");
        return self.getInventory(curSize, curColor);
    };

    self.checkInventory = function(curSize, curColor) {
        self.setSwatchState(curSize, curColor);
        return [
            self.productRoot.find(".swatch-size:not(.sold-out)").length,
            self.productRoot.find(".swatch-image:not(.sold-out)").length
        ];
    };

    self.updateLdJson = function(curColor, curSize) {
        if (self.ldJsonTemplate) {
            var data = {
                name: self.productRoot.find(".product-name").html(),
                style: self.productRoot.find(".product-style").html(),
                sku: null,
                price: null,
                stock: "InStock"
            };
            var item = self.getInventory(curSize, curColor);
            if (item) {
                data = $.extend({}, data, {
                    style: item.style,
                    sku: item.style + (curColor + "    ").substring(0, 4) + curSize,
                    price: Number(item.price).toFixed(2),
                    stock: item.avail ? "InStock" : "OutOfStock"
                });
            }
            var html = self.ldJsonTemplate.render(data);
            $("#product-ld-json").html(html);
        }
    };

    self.updateRelatedProducts = function(curColor, standardColor, curSize) {
        $.each(self.config.relatedProducts, function(idx, pm) {
            pm.trackParentSelection(curColor, standardColor, curSize);
        });
        self.updateRelatedTab();
    };

    self.updateRelatedTab = function() {
        // Count visible related products
        var count = $(".purchase-tile:not(.inactive)").length;
        if (count) {
            // Show & Open CTL tab
            $('#detailTabs a[href="#complete"]')
                .closest("li")
                .show();
            $('#detailTabs a[href="#complete"]').tab("show");
        } else {
            // Hide CTL tab, open first tab
            var tab = $('#detailTabs a[href="#complete"]').closest("li");
            tab.hide();
            if (tab.hasClass("active")) {
                $("#detailTabs a:visible:first").tab("show");
            }
        }
    };

    self.trackParentSelection = function(parentColor /* standardColor, parentSize */) {
        // Hide everything
        self.productRoot.hide().addClass("inactive");
        self.productRoot.find("[data-size-type]").hide();
        self.productRoot.find(".product-image").hide();
        self.productRoot
            .find(".swatch-image")
            .removeClass("selected")
            .hide();

        // Update sizeType display
        var ctl = self.productRoot.find('[data-size-type="' + self.sizeType + '"]');
        if (ctl && ctl.length) {
            ctl.show();

            // Update visible color image & swatch
            if (parentColor) {
                // Handle color mapping
                var mappedColors = window.jrConfig.colorMapping[parentColor] || [parentColor];
                parentColor = null;

                $.each(mappedColors, function(idx, color) {
                    ctl = self.productRoot.find('.swatch-image[data-colorcode="' + color + '"]');
                    if (ctl && ctl.length) {
                        // MATCHING COLOR EXISTS
                        self.productRoot.show().removeClass("inactive");
                        ctl.addClass("selected").show();
                        self.productRoot
                            .find(".price-container")
                            .html(ctl.closest("[data-color-price]").data("color-price"));
                        self.productRoot
                            .find('.product-image[data-colorcode="' + color + '"]')
                            .show();
                        self.updateControls(false);

                        // UPDATE SIZES
                        var curSize = self.productRoot
                            .find(".swatch-size.selected")
                            .data("stylesize");
                        self.setSwatchState(curSize, color);
                        parentColor = color;
                        return false;
                    }
                });
            } else {
                // NO COLOR SELECTED
            }
        } else {
            // NOT AVAILABLE IN SIZE TYPE
        }
    };

    self.updateAlternateImages = function(colorcode) {
        self.productRoot.find(".alternate-images[data-colorcode]").hide();
        if (colorcode) {
            self.productRoot.find('.alternate-images[data-colorcode="' + colorcode + '"]').show();
        } else {
            self.productRoot.find('.alternate-images[data-colorcode=""]').show();
        }
    };

    self.updateControls = function(turn_off) {
        // Reset waitlist
        self.waitlistReset();

        // Grab current values
        var curSize = self.productRoot.find(".swatch-size.selected").data("stylesize");
        var curColor = self.productRoot.find(".swatch-image.selected").data("colorcode");

        var cnts = self.checkInventory(curSize, curColor);
        var sizeCnt = cnts[0];
        var colorCnt = cnts[1];

        // Rebuild
        var item;
        if (sizeCnt == 1) {
            item = self.productRoot.find(".swatch-size:not(.sold-out)");
            if (turn_off) {
                item.removeClass("selected");
                curSize = undefined;
                self.setSwatchState(curSize, curColor);
            } else if (
                curSize != item.data("stylesize") &&
                self.productRoot.find(".swatch-size").length == 1
            ) {
                item.addClass("selected");
                curSize = item.data("stylesize");
                self.setSwatchState(curSize, curColor);
            }
        }

        if (colorCnt == 1) {
            item = self.productRoot.find(".swatch-image:not(.sold-out)");
            if (turn_off) {
                item.removeClass("selected");
                curColor = undefined;
                self.setSwatchState(curSize, curColor);
            } else if (
                curColor != item.data("colorcode") &&
                self.productRoot.find(".swatch-image").length == 1
            ) {
                item.addClass("selected");
                curColor = item.data("colorcode");
                self.setSwatchState(curSize, curColor);
            }
        }

        // Update query string
        var urlParams = "#";

        // Update hidden inputs and button states
        self.productRoot.find('input[name="stylesize"]').val(curSize);
        self.productRoot.find('input[name="colorcode"]').val(curColor);
        if (curColor && curSize) {
            self.productRoot.find(".select_options").hide();
            urlParams +=
                "color=" + encodeURIComponent(curColor) + "&size=" + encodeURIComponent(curSize);
        } else {
            var msg = "";
            if (curSize) {
                urlParams += "size=" + encodeURIComponent(curSize);
                msg = "color";
            } else if (curColor) {
                urlParams += "color=" + encodeURIComponent(curColor);
                msg = "size";
            } else {
                msg = "color and size";
            }
            self.productRoot.find(".select_error").html(msg);
        }

        if (self.config.isMaster) {
            self.setColorImage(curColor);

            // Update complete the look images
            self.updateRelatedProducts(
                curColor,
                self.productRoot.find(".swatch-image.selected").data("standard-color"),
                curSize
            );
            self.updateAlternateImages(curColor);

            self.updateLdJson(curColor, curSize);

            // Ignore state changes until initialization is complete
            if (self.initComplete) {
                if (urlParams != "#") {
                    location.replace(urlParams);
                } else {
                    var scrollV,
                        scrollH,
                        loc = window.location;
                    if ("pushState" in history) {
                        history.pushState("", document.title, loc.pathname + loc.search);
                    } else {
                        // Prevent scrolling by storing the page's current scroll offset
                        scrollV = document.body.scrollTop;
                        scrollH = document.body.scrollLeft;

                        loc.hash = "";

                        // Restore the scroll offset, should be flicker free
                        document.body.scrollTop = scrollV;
                        document.body.scrollLeft = scrollH;
                    }
                }
            }
        }

        // Quantity always last
        self.productRoot.find(".backorder, .low_stock").hide();
        var qty = 1;
        var data = self.getInventory(curSize, curColor);
        if (data && data.avail) {
            var avail = data.qty;
            if (avail > 0) {
                // Update qty display
                self.productRoot.find(".qty_avail").html(avail == 1 ? "1" : "a few");
                if (avail <= 2) {
                    self.productRoot.find(".low_stock").show();
                }
                qty = Math.min(5, avail);
            } else {
                // Limit qty on backorders
                qty = 3;
                self.productRoot.find(".backorder").show();
            }
        }

        // Rebuild if we need to
        var qtyCtl = self.productRoot.find('select[name="qty"]');
        if (qtyCtl && qtyCtl.length) {
            if (self.productRoot.find('select[name="qty"] option').length != qty) {
                var curQty = qtyCtl.val();
                self.productRoot.find('select[name="qty"] > option').remove();
                for (var i = 1; i <= qty; i++) {
                    qtyCtl.append($("<option>", { value: i, text: i }));
                }
                qtyCtl.val(curQty ? curQty : "1");
            }
        }
    };

    self.setColorImage = function(colorcode) {
        colorcode = colorcode || "";
        var type = self.productRoot.find('input[name="size-type"]:checked').val();
        if (!self.slideChange) {
            var index = self.productRoot
                .find('[data-size-type="' + type + '"]')
                .find('.swiper-slide[data-colorcode="' + colorcode.trim() + '"]')
                .data("swiper-slide-index");
            if (index >= 0 && self.swiper && self.swiper.slideTo) {
                self.swiper.slideTo(index + 1, 250);
            }
        }
        if (self.productRoot.find(".pinterest-link").length) {
            // Update pinterest href
            var img = self.productRoot
                .find('[data-size-type="' + type + '"]')
                .find('.swiper-slide[data-colorcode="' + colorcode.trim() + '"]')
                .find("img")
                .attr("src");
            if (img) {
                img = img.replace(/webp/, "jpg");
                self.productRoot.find(".pinterest-link").attr(
                    "href",
                    self.productRoot
                        .find(".pinterest-link")
                        .attr("href")
                        .replace(/media=[^&]+/, "media=" + encodeURIComponent(img))
                );
            }
        }
    };

    self.handleSelection = function(ctl, selector) {
        var turn_off = false;
        if (ctl.hasClass("selected")) {
            self.productRoot.find(selector).removeClass("selected");
            turn_off = true;
        } else {
            self.gaEvent(selector == ".swatch-size" ? "chooseSize" : "chooseColor");
            self.productRoot.find(selector).removeClass("selected");
            ctl.addClass("selected");
        }
        self.updateControls(turn_off);
    };

    self.productRoot.find(".swatch-size").click(function(e) {
        e.preventDefault();
        self.handleSelection($(this), ".swatch-size");
        return false;
    });

    self.productRoot.find('input[type="submit"]').click(function(e) {
        e.preventDefault();
        var item = self.currentItem();
        if (item) {
            self.gaEvent("addToBag");
            var qty = self.productRoot.find('select[name="qty"]').length
                ? self.productRoot.find('select[name="qty"]').val()
                : 1;
            $cm.addItem(item.id, item.colorcode, item.stylesize, qty, function() {
                if (!self.config.isMaster) {
                    self.productRoot.addClass("inactive").fadeOut(800, function() {
                        self.updateRelatedTab();
                        this.remove();
                    });
                }
            });
        } else {
            self.productRoot.find(".select_options").show();
        }
    });

    self.preparePurchase = function() {
        var success = false;
        var item = self.currentItem();
        if (item) {
            self.gaEvent("applePay");
            $.ajaxSetup({ async: false }); // Need item in cart BEFORE apple pay session is created!
            var qty = self.productRoot.find('select[name="qty"]').length
                ? self.productRoot.find('select[name="qty"]').val()
                : 1;
            $cm.purchaseItem(item.id, item.colorcode, item.stylesize, qty, function(/* cart */) {
                success = true;
            });
        } else {
            self.productRoot.find(".select_options").show();
        }
        return success;
    };

    self.productRoot.find(".btn-wishlist").click(function(e) {
        e.preventDefault();
        var item = self.currentItem();
        if (item) {
            self.gaEvent("wishlist");
            self.productRoot
                .find('form[name="product"]')
                .attr("method", "GET")
                .attr("action", "/account/wishlist/add")
                .submit();
        } else {
            self.productRoot.find(".select_options").show();
        }
    });

    self.waitlistReset = function() {
        self.productRoot.find(".btn-notify").show();
        self.productRoot.find(".waitlist").hide();
        self.productRoot.find(".waitlist-result").hide();
    };

    self.productRoot.find(".btn-notify").click(function(e) {
        e.preventDefault();
        // Hide notify / show email input
        self.productRoot.find(".btn-notify").hide();
        self.productRoot.find(".waitlist").show();
    });

    self.waitlistRequest = function(e) {
        e.preventDefault();
        var item = self.currentItem();
        if (item) {
            var email = self.productRoot.find(".waitlist-email").val();
            if (email) {
                self.gaEvent("waitlist");
                $cm.waitlist(item.id, item.colorcode, item.stylesize, email, function(result) {
                    $(".waitlist").hide();
                    if (result) {
                        self.productRoot.find(".waitlist-result.alert-success").show();
                    } else {
                        self.productRoot.find(".waitlist-error.alert-danger").show();
                    }
                });
            }
        } else {
            self.productRoot.find(".select_options").show();
        }
        return false;
    };

    self.productRoot.find(".waitlist-email").keydown(function(e) {
        if (e.keyCode == 13) {
            return self.waitlistRequest(e);
        }
    });
    self.productRoot.find(".btn-waitlist").click(self.waitlistRequest);

    if (self.config.isMaster) {
        self.productRoot.find('input[name="size-type"]').change(self.sizeTypeChange);

        self.productRoot.find(".swatch-image").click(function(e) {
            e.preventDefault();
            self.handleSelection($(this), ".swatch-image");
            return false;
        });

        self.productRoot.find(".fancybox").fancybox({
            loop: true,
            beforeShow: function() {
                self.gaEvent("lightbox");
            }
        });

        self.productRoot.find(".show-all-colors").click(function(e) {
            $(this).hide();
            self.productRoot.find(".regular-price").fadeIn();
            self.updateControls();
        });

        // General initialization first
        var ctl, size, color, sizeType;

        // Check for sale only
        if (qd["sale"] && self.productRoot.find(".discount-price").length) {
            if (self.productRoot.find(".regular-price").length) {
                self.productRoot.find(".show-all-colors").show();
            }
        } else {
            self.productRoot.find(".regular-price").show();
        }

        // Check for stylesize
        size = qd["size"] ? decodeURIComponent(qd["size"]) : null
        color = qd["color"] ? decodeURIComponent(qd["color"]) : null;
        sizeType = size
            ? self.productRoot
                  .find('.swatch-size[data-stylesize="' + size + '"]')
                  .closest("[data-size-type]")
                  .data("size-type")
            : null;
        if (sizeType) {
            self.productRoot.find('input[name="size-type"]').val([sizeType]);
        } else {
            sizeType = color
                ? self.productRoot
                    .find('.swatch-image[data-colorcode="' + color + '"]')
                    .closest("[data-size-type]")
                    .data("size-type")
                : null;
            if (sizeType) {
                self.productRoot.find('input[name="size-type"]').val([sizeType]);
            } else {
                self.productRoot.find('input[name="size-type"]:first').prop("checked", true);
            }
        }
        self.sizeTypeChange();

        // Now, query string overrides
        if (size) {
            ctl = self.productRoot.find('.swatch-size[data-stylesize="' + size + '"]');
            if (
                ctl &&
                ctl.length &&
                size != self.productRoot.find(".swatch-size.selected").data("stylesize")
            ) {
                self.handleSelection(ctl, ".swatch-size");
            }
        }

        if (color) {
            ctl = self.productRoot.find('.swatch-image[data-colorcode="' + color + '"]');
            if (
                ctl &&
                ctl.length &&
                color != self.productRoot.find(".swatch-image.selected").data("colorcode")
            ) {
                self.handleSelection(ctl, ".swatch-image");
            }
        }

        // Set initial ldJson to match input
        if (color || size) {
            self.updateLdJson(color, size);
        } else {
            self.updateRelatedProducts();
        }

        if (qd["item"]) {
            setTimeout(function() {
                $('#detailTabs a[href="#complete"]').tab("show");
                $("html, body").animate({
                    scrollTop: $('a[name="product-tabs"]').offset().top
                });
            }, 1500);
        }
    }

    self.initComplete = true;
}
